import { TMoneySourcesState } from '../../../../reducers/v2';

import { EMoneySourceWidgetType, IMoneySourceProps } from '../../types';
import { MONEY_SOURCE_OPTION_LABELS_BY_TYPE } from '../../constants';

interface IParams {
  sources: TMoneySourcesState;
  widgetType: EMoneySourceWidgetType;
}

export const getOptions = ({ sources, widgetType }: IParams): Array<IMoneySourceProps> => {
  return sources
    .sort(source => (source.type === 'master' ? -1 : 1))
    .map(({ disabled, type, selected }) => {
      return {
        disabled,
        label: MONEY_SOURCE_OPTION_LABELS_BY_TYPE[widgetType][type],
        active: selected,
        value: type,
      };
    });
};
